import { Route } from 'src/routes/Route'

export const AwardsRoute = Route({ path: '/awards' })
export type AwardsRoute = Route<typeof AwardsRoute>
